import React from 'react';
import { Paper, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import LeadInsightField from './LeadInsightField';

// Resumo da conversa gerado pela IA — sem tamanho fixo, por isso é limitado a
// algumas linhas (com "...") em vez de crescer o card indefinidamente.
const LeadContext = ({ context, sentimentEmoji }) => {
  const { t } = useTranslation();

  if (!context) return null;

  return (
    // Elevação 1, não outlined: no dark o Paper outlined fica da cor da página (preto).
    <Paper elevation={1} sx={{ p: 1.5, position: 'relative' }}>
      <LeadInsightField label={t('leads.context')}>
        <Typography
          variant="body2"
          sx={{
            display: '-webkit-box',
            WebkitLineClamp: 4,
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden',
            pr: sentimentEmoji ? 3 : 0,
          }}
        >
          {context}
        </Typography>
      </LeadInsightField>

      {sentimentEmoji && (
        <Typography variant="h6" component="span" sx={{ position: 'absolute', top: 10, right: 12 }}>
          {sentimentEmoji}
        </Typography>
      )}
    </Paper>
  );
};

export default LeadContext;
